import './styles.scss'
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import JoditEditor from 'jodit-react'

import endpoints from 'constants/endpoints'
import { getHeaders } from 'api/helpers'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'
import { getPasteText, joditPopupEvent, joditConfig } from './utils'
import getControls from './editorControls'

const HtmlEditor = (props) => {
  const {
    value, placeholder, onPasteAttachments, minHeight = 273, maxHeight = 273,
    onChange, className, readonly = false, setInstance, channel, isSmall,
    defaultValue, editorCssClass, onKeyUp, isTemplate, enter = 'BR',
    buttonCloseEvent, displayAddVars = false, withAttachments = true
  } = props

  const [content, setContent] = useState(defaultValue)
  const [defaultLoaded, setDefaultLoaded] = useState(false)
  const company = useSelector((store) => store.companies)
  const locale = useSelector((store) => store.user?.locale || 'es')
  let refEditor = null

  useEffect(() => {
    if (defaultValue && !defaultLoaded) {
      setDefaultLoaded(true)
      setContent(defaultValue)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue])

  useEffect(() => {
    value && setContent(value)
  }, [value])

  const config = useMemo(() => {
    return {
      ...joditConfig({
        minHeight, maxHeight, readonly, locale,
        editorCssClass, channel, isSmall, enter,
        displayAddVars,
        placeholder: placeholder || lang('dashboard_write-message')
      }),
      popup: joditPopupEvent(),
      ...withAttachments ? {
        uploader: {
          url: endpoints.endpoints.resource.resources,
          headers: getHeaders(true, true),
          filesVariableName: function(i){
            return "files"
          },
          withCredentials: false,
          format: "json",
          method: "POST",
          imagesExtensions: ['jpg', 'png', 'jpeg', 'gif'],
          prepareData: function(formData){
            const data = {
              companyType: company.type,
              companyToken: company.hash,
            }
            formData.append('data', JSON.stringify(data))
            return formData
          },
          isSuccess: function (resp) {
            return !resp.error
          },
          getMessage: function (resp) {
            return resp.msgs.join('\n')
          },
          process: function (resp) {
            return resp
          },
          defaultHandlerSuccess: function (resp) {
            onPasteAttachments(resp.attachments || [])
          }
        }
      } : {},
      events: {
        afterInit: (instance) => {
          setInstance(instance)
          // eslint-disable-next-line react-hooks/exhaustive-deps
          refEditor = instance
        },
        getIcon: function (name, control, clearName) {
          if (!name) return null

          let code = clearName
          // eslint-disable-next-line default-case
          switch (clearName) {
            case 'brush':
              code = 'tint'
              break
            case 'fontsize':
              code = 'text-height'
              break
            case 'ul':
            case 'ol':
              code = 'list-' + name
              break
            case 'source':
              code = 'HTML'
              break
            case 'left':
            case 'right':
            case 'justify':
            case 'center':
              code = 'align-' + name
              break
          }

          return clearName === 'source'
            ? `<img style="width:24px; height=13px;" src="${getStaticImage('/icons/orange-brand/icon-html.png')}"/>`
            : '<i style="font-size:14px" class="fa fa-' + code + ' fa-xs"></i>'
        },
        keyup: function (e) {
          onKeyUp && onKeyUp(e)
        },
        ...!isTemplate ?
          {
            processPaste: function(event, html){
              if (refEditor) {
                refEditor.withPaste = true
                refEditor.selection.insertHTML(getPasteText(html))
                refEditor.tempContent = refEditor.getEditorValue()
              }
            },
            afterPaste: function(event){
              let el = document.createElement('div')
              el.innerHTML = refEditor.tempContent ? refEditor.tempContent : refEditor.getEditorValue()

              if(!refEditor.withPaste) {
                el.innerHTML = getPasteText(el.innerHTML)
              }

              refEditor.withPaste = false
              refEditor.setEditorValue(el.innerHTML)
              refEditor.tempContent = null
            },
          }
          : {}
      },
      controls: getControls()
    }
  }, [placeholder, minHeight, maxHeight, editorCssClass, channel, isTemplate, locale, readonly, displayAddVars])

  return (
    <div className='html-editor-container'>
      <JoditEditor
        tabIndex={1}
        className={className?.trim()}
        value={content}
        config={config}
        readonly={readonly}
        onBlur={newContent => { setContent(newContent) }} // preferred to use only this option to update the content for performance reasons
        onChange={(d) => {
          if (defaultLoaded) setDefaultLoaded(true)
          onChange(d)
        }}
      />
      {
        buttonCloseEvent
          ? (
            <button className='editor-button-close' onClick={buttonCloseEvent} type="button" >
              <img src='https://assets.nixi1.dkv.es/dashboard_front/images/icon-close-2.svg' alt='button-close' />
            </button>
          ) : null
      }
    </div>
  )
}

export default HtmlEditor
